import { isNil } from 'lodash'
import cx from 'classnames'

import { Link } from 'features/i18n/router'
import { useScrollToPost } from '../PostItem/PostItem.hooks'
import { Group, Post } from 'lib/_types'
import { ROUTE_PATH } from 'lib/paths'

import ReplyTo from 'components/ReplyTo'
import PostAvatar from '../PostItem/PostAvatar'
import PostUserName from '../PostItem/PostUserName'
import PostTime from '../PostItem/PostTime'
import PostContent from 'components/Post/PostContent'

import './style.scss'

const PostShareablePost = ({
  post,
  group,
  disabled,
}: {
  post: Post
  group?: Partial<{ data: Group }>
  disabled?: boolean
}) => {
  const { rootRef } = useScrollToPost({ post, rootRef: null })

  return (
    <div
      className={cx('PostShareablePost', {
        'PostShareablePost--disabled': disabled,
      })}
    >
      <Link
        className="PostShareablePost__handle"
        to={
          post?.group_id
            ? post?.conversation_id
              ? ROUTE_PATH.GROUP_CONVERSATION(
                  post?.group_id,
                  post?.conversation_id
                )
              : ROUTE_PATH.GROUP_POST(post?.group_id, post?.id)
            : post?.conversation_id
            ? ROUTE_PATH.CONVERSATION(post?.conversation_id)
            : ROUTE_PATH.POST(post?.id)
        }
        draggable={false}
      />

      <div
        id={`post-${post?.id}`}
        ref={rootRef}
        className={cx('PostList__item', 'PostList__item--last')}
      >
        <div className="PostShareablePost__header">
          <PostAvatar user={post?.user} />
          <PostUserName user={post?.user} />
          <PostTime createdAt={post?.created_at} />
        </div>

        <div className="PostShareablePost__content">
          {!isNil(post?.in_reply_to_post) && (
            <ReplyTo post={post} repliedPost={post?.in_reply_to_post} />
          )}

          <PostContent post={post} group={group} isShared />
        </div>
      </div>
    </div>
  )
}

export default PostShareablePost
